import React, { useState, useRef, useEffect } from "react";
import AudioRecorder from "../Navigation/Course/Content/CodeVaani/Student/AudioRecorder";
import httpService from "services/httpService";
import * as constants from "Constants";
import {
  FaRegThumbsUp,
  FaRegThumbsDown,
  FaPencilAlt,
} from "react-icons/fa";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import { Tooltip } from "bootstrap";
import { marked } from "marked";
import DOMPurify from "dompurify";
import toWav from "audiobuffer-to-wav";

export const CodeVaani = ({ courseId, labId, activityID }) => {
  // console.log("Codevaani Mounted");
  // const { courseId, labId, activityID } = useParams();
  // console.log(courseId, labId, activityID);

  // States
  const [currLabTitle, setCurrLabTitle] = useState("");
  const [currActivityTitle, setCurrActivityTitle] = useState("");
  const [courseName, setCourseName] = useState("");
  const [labList, setLabList] = useState([]);
  const [activityList, setActivityList] = useState([]);
  const [selectedLab, setSelectedLab] = useState("");
  const [selectedActivity, setSelectedActivity] = useState("");
  const [labTitle, setLabTitle] = useState("");
  const [activityTitle, setActivityTitle] = useState("");
  const [problemStatement, setProblemStatement] = useState("");
  // const [solutionCode, setSolutionCode] = useState("");
  const [taskId, setTaskId] = useState(null);
  const [asrTranscription, setAsrTranscription] = useState("");
  const [llmResponse, setLlmResponse] = useState("");
  const [editedQuery, setEditedQuery] = useState(false);

  const [parentCodevaaniId, setParentCodevaaaniId] = useState(null);
  const [codevaaniId, setCodevaaniId] = useState(null);
  const [transcribeTaskId, setTranscribeTaskId] = useState(null);
  const [inferenceTaskId, setInferenceTaskId] = useState(null);

  //Loading States for Transcription and Inference
  const [loadingTranscription, setLoadingTranscription] = useState(false);
  const [loadingInference, setLoadingInference] = useState(false);

  // Transcription language
  const [selectedTranscriptLang, setSelectedTranscriptLang] =
    useState("english");

  // for initial data load
  const [dataReady, setDataReady] = useState(false);
  const [initialDataLoad, setInitialDataLoad] = useState(true);

  // Whether audio sent or not
  const [audioSent, setAudioSent] = useState(false);

  // Feedback
  const [askTranscriptionFeedback, setAskTranscriptionFeedback] =
    useState(false);
  const [askResponseFeedback, setAskResponseFeedback] = useState(false);
  const [transcriptionRated, setTranscriptionRated] = useState(false);
  const [responseRated, setResponseRated] = useState(false);

  const [transcriptionLanguageList, setTranscriptionLanguageList] = useState(
    [],
  );
  const [labActivityList, setLabActivityList] = useState([]);

  // Whether transcription changed or not
  const [isEditingTranscription, setIsEditingTranscription] = useState(false);
  const [editedTranscription, setEditedTranscription] = useState("");
  // For usage instructions popup
  const [showUsageInstructions, setShowUsageInstructions] = useState(false);

  const handleCloseInstructionPopUp = () => setShowUsageInstructions(false);
  const handleShowInstructionPopUp = () => setShowUsageInstructions(true);

  const [selectedTransriptFeedback, setSelectedTranscriptFeedback] =
    useState(null); // "like" | "dislike" | null
  const [selectedInferenceFeedback, setSelectedInferenceFeedback] =
    useState(null);

  const [selectedUserAction, setSelectedUserAction] = useState(null);
  const [codevaaniEnabled, setCodevaaniEnabled] = useState(null);
  const [codevaaniAvailable, setCodeVaaniAvailable] = useState(true);

  const currentRequestRef = useRef(null);
  const editorPageRef = useRef(null);
  const solutionCodeRef = useRef("");
  // const codeVaaniEnabledRef = useRef(true);

  // --- Initial load ---
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const courseRes = await httpService.get(
          `${constants.base_url}/courseware/api/course/${courseId}/get_full_course_detail/`,
        );
        // console.log("Course", courseRes)
        if (courseRes?.data?.title) setCourseName(courseRes.data.title);
        // if (courseRes?.data?.enable_codevaani) setCodevaaniEnabled(courseRes.data.enable_codevaani);
        console.log("Course Details: ", courseRes?.data);
      } catch (err) {
        setCodeVaaniAvailable(false);
        console.error(`Error getting the course details: ${err}`);
      }

			// try {
			// 	const editorPageReq = await httpService.get(
			// 		`${constants.base_url}/evalpro/editor/${activityID}`,
			// 	);
			// 	if (editorPageReq?.data) setSolutionCode(editorPageReq.data?.editor_buffer?.buffer_data?.add);
			// } catch (err) {
			// 	console.error("Editor page request: ", err)
      // }

      let isEnabled = false;
      try {
        const problemStatementRes = await httpService.get(
          `${constants.base_url}/evalpro/voicebot/problem_statement/${activityID}`,
        );
        if (problemStatementRes?.data) {
          console.error("Problem Statement", problemStatementRes?.data?.data);
          setProblemStatement(
            problemStatementRes?.data?.data?.problem_statement,
          );
          setCurrLabTitle(problemStatementRes?.data?.data?.lab_title);
          setCurrActivityTitle(problemStatementRes?.data?.data?.activity_title);
          isEnabled =
            problemStatementRes?.data?.access_control_vars
              .enable_show_codevaani;
          // console.log("isEnabled PS"+isEnabled);
          if (isEnabled !== null) {
            setCodevaaniEnabled(isEnabled);
          } else {
            setCodevaaniEnabled(false);
          }
        }
      } catch (err) {
        console.error(`Error getting Activity Problem Statement: ${err}`);
        setCodevaaniEnabled(false);
      }

      try {
        const labActivityRes = await httpService.get(
          `${constants.base_url}/evalpro/voicebot/labs_activities_list/${courseId}`,
        );
        if (labActivityRes?.data) {
          // console.log("LA: ", JSON.stringify(labActivityRes?.data?.data?.labs));
          setLabActivityList(labActivityRes?.data?.data?.labs);
          const labs = labActivityRes?.data?.data?.labs.map((lab) => ({
            lab_title: lab.lab_title,
            lab_id: lab.lab_id,
          }));
          // console.log("Lab List", labs);
          setLabList(labs);
          if (isEnabled) {
            const labs_activities = labActivityRes?.data?.data?.labs;
            const exists = labs_activities.some(
              (lab) =>
                String(lab.lab_id) === labId &&
                lab.activities.some(
                  (activity) => String(activity.activity_id) === activityID,
                ),
            );
            // console.log("ex: "+exists);
            if (exists) {
              setSelectedLab(labId);
              setSelectedActivity(activityID);
            } else {
              setSelectedLab("");
              setSelectedActivity("");
            }
          } else {
            setSelectedLab("");
            setSelectedActivity("");
          }
          setParentCodevaaaniId(null);
        }
      } catch (err) {
        console.log(`Error getting lab list: ${err}`);
      }

      try {
        const transcriptionLangRes = await httpService.get(
          `${constants.base_url}/evalpro/voicebot/supported_languages`,
        );
        if (transcriptionLangRes?.data) {
          setTranscriptionLanguageList(
            transcriptionLangRes?.data?.data?.supported_languages,
          );
          // console.log(transcriptionLangRes?.data?.data?.supported_languages);
        }
      } catch (err) {
        console.error(`Error getting Transcription Languages: ${err}`);
      }
    };
    fetchInitialData();
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]',
    );
    [...tooltipTriggerList].map(
      (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl),
    );
  }, []);

  useEffect(() => {
    if (
      (problemStatement !== null &&
        problemStatement !== "" &&
        transcriptionLanguageList.length > 0) ||
      codevaaniEnabled === false
    ) {
      // console.log("enabled: "+ codevaaniEnabled);
      setDataReady(true);
      setInitialDataLoad(false);
      const lab_title = labList.find(
        (item) => item.lab_id == selectedLab,
      )?.lab_title;
      const activity_title = activityList.find(
        (item) => item.activity_id == selectedActivity,
      )?.activity_title;
      setLabTitle(!initialDataLoad ? lab_title : currLabTitle);
      setActivityTitle(!initialDataLoad ? activity_title : currActivityTitle);
      // console.log("activity_title: "+activity_title);
    }
  }, [problemStatement, transcriptionLanguageList, codevaaniEnabled]);

  // --- Lab change → Fetch activities ---
  useEffect(() => {
    const fetchActivities = async () => {
      if (!selectedLab) return;
      try {
        // filter labActivitiesList to get activities of selected lab
        // console.log("labActivityList: ", labActivityList);
        const lab = labActivityList.find(
          (l) => l.lab_id === Number(selectedLab),
        );
        // console.log("Selected Lab: ", lab);
        if (lab) {
          // console.log("Fetched Activities", lab.activities);
          setActivityList(lab.activities);
          if (!initialDataLoad) {
            setSelectedActivity("");
            setProblemStatement("");
          }
        } else {
          setActivityList([]);
        }
      } catch (err) {
        console.log(`Error getting activities: ${err}`);
      }
      // console.log("Selected Lab: ", selectedLab);
    };
    fetchActivities();
  }, [selectedLab]);

  // --- Activity change → Fetch problem statement ---
  useEffect(() => {
    const fetchProblemStatement = async () => {
      if (selectedActivity === "") return;
      try {
        let activity_id = selectedActivity;
        const problemStatementRes = await httpService.get(
          `${constants.base_url}/evalpro/voicebot/problem_statement/${activity_id}`,
        );
        if (problemStatementRes?.data) {
          // console.log("New Problem Statement", problemStatementRes?.data?.data?.problem_statement);
          setProblemStatement(problemStatementRes.data.data.problem_statement);
        }
      } catch (err) {
        console.error(`Error getting the problem statement: ${err}`);
      }
    };
    fetchProblemStatement();
  }, [selectedActivity]);

  const convertToWav = async (blob) => {
    const arrayBuffer = await blob.arrayBuffer();
    const audioCtx = new AudioContext();
    const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer);

    // Convert AudioBuffer → WAV ArrayBuffer
    const wavBuffer = toWav(audioBuffer);
    return new Blob([wavBuffer], { type: "audio/wav" });
  };

  // --- Send New CodeVaani Request ---
  const handleNewRequest = async (blob) => {
    // Fetch current code from editor buffer 
    try {
      const editorPageReq = await httpService.get(
        `${constants.base_url}/evalpro/editor/${activityID}`,
      );
      let code = editorPageReq.data?.editor_buffer?.buffer_data;
      let k = Object.keys(code)[0]
      if (editorPageReq?.data) solutionCodeRef.current = (code[k]);
    } catch (err) {
      console.error("Editor page request: ", err)
    }

    // Check if all required fields are not NULL / Empty
    let solutionCode = solutionCodeRef.current;
    // if (!solutionCode || solutionCode?.trim() === "") {
    //   displayGlobalMessage(
    //     "Code is required for answering your Question",
    //     "error",
    //   );
    //   return;
    // }

    const normalize = (str = "") =>
      str
        .replace(/\r?\n|\r/g, "")
        .replace(/<br\s*\/?>/gi, "<br>")
        .trim();

    if (
      !problemStatement ||
      normalize(problemStatement) == normalize("")
    ) {
      displayGlobalMessage(
        "Problem Statement is required for answering your Question",
        "error",
      );
      return;
    }

    const requestId = Date.now();
    currentRequestRef.current = requestId;

    setEditedQuery(false);
    setLoadingTranscription(true);
    setAskResponseFeedback(false);
    setAskTranscriptionFeedback(false);
    setAudioSent(false);
    setLoadingInference(true);
    setResponseRated(false);
    setEditedTranscription("");
    setTranscriptionRated(false);
    setTranscribeTaskId(null);
    setInferenceTaskId(null);
    setCodevaaniId(null);
    setSelectedTranscriptFeedback(null);
    setSelectedInferenceFeedback(null);
    setAsrTranscription("");
    setLlmResponse("");
    setSelectedUserAction(null);
    setIsEditingTranscription(false);

    const wavBlob = await convertToWav(blob);

    const formData = new FormData();
    // console.log("Edited Query: ", editedQuery);
    formData.append(
      "audio_file",
      wavBlob,
      `lab${selectedLab?.id}_activity${selectedActivity?.title}-${Date.now()}-${Math.random()}.wav`,
    );
    formData.append("problem_statement", problemStatement);
    formData.append("code_solution", solutionCode);
    formData.append("language", selectedTranscriptLang);
    formData.append("edited_query", false);
    formData.append(
      "parent_codevaani_id",
      parentCodevaaniId === null ? 0 : parentCodevaaniId,
    );

    try {
      const res = await httpService.post(
        `${constants.base_url}/evalpro/voicebot/new_request/${activityID}`,
        formData,
      );
      if (res?.data) {
        // console.log("New Request Response", res.data);
        const cvid = res?.data?.data?.codeVaani_id;
        const task_id = res?.data?.data?.task_id;
        // console.log("Codevaani Id: ", cvid);
        // console.log("Edited Query1: ", editedQuery);
        setCodevaaniId(cvid);
        setTranscribeTaskId(res?.data?.data?.transcribe_task_id || null);
        setInferenceTaskId(res?.data?.data?.inference_task_id);
        setAudioSent(true);
        // console.log("Codevaani 0: ", codevaaniId);
        addTaskIdToCodevaani(cvid, false, task_id, requestId);
      }
    } catch (error) {
      console.log(`Error sending audio: ${error}`);
      setLoadingTranscription(false);
      setLoadingInference(false);
      setAskResponseFeedback(false);
      setAskTranscriptionFeedback(false);
      displayGlobalMessage(
        error?.response?.data?.detail || "Request Failure, Please Try Again.",
        "error",
      );
    }
  };

  // --- Send Edited Transcription Request ---
  const sendRequestWithEditedTranscription = async () => {
    // Fetch current code from editor buffer 
    try {
      const editorPageReq = await httpService.get(
        `${constants.base_url}/evalpro/editor/${activityID}`,
      );
      if (editorPageReq?.data) solutionCodeRef.current = (editorPageReq.data?.editor_buffer?.buffer_data?.add);
    } catch (err) {
      console.error("Editor page request: ", err)
    }

    // Check if all required fields are not NULL / Empty
    let solutionCode = solutionCodeRef.current;
    // if (!solutionCode || solutionCode?.trim() === "") {
    //   displayGlobalMessage(
    //     "Code is required for answering your Question",
    //     "error",
    //   );
    //   return;
    // }

    const normalize = (str = "") =>
      str
        .replace(/\r?\n|\r/g, "")
        .replace(/<br\s*\/?>/gi, "<br>")
        .trim();

    if (
      !problemStatement ||
      normalize(problemStatement) == normalize("")
    ) {
      displayGlobalMessage(
        "Problem Statement is required for answering your Question",
        "error",
      );
      return;
    }

    if (!editedTranscription) {
      displayGlobalMessage(
        "Query is required for answering your Question",
        "error",
      );
      return;
    }

    const requestId = Date.now();
    currentRequestRef.current = requestId;

    setIsEditingTranscription(false);
    setAsrTranscription(editedTranscription);
    setAskResponseFeedback(false);
    setAskTranscriptionFeedback(false);
    setEditedQuery(true);
    setLoadingInference(true);
    setLoadingTranscription(false);
    setResponseRated(false);
    setTranscriptionRated(false);
    setTranscribeTaskId(null);
    setInferenceTaskId(null);
    setSelectedTranscriptFeedback(null);
    setSelectedInferenceFeedback(null);
    setLlmResponse("");
    setSelectedUserAction(null);

    const formData = new FormData();
    formData.append("problem_statement", problemStatement);
    formData.append("code_solution", solutionCode);
    formData.append("language", selectedTranscriptLang);
    formData.append("edited_query", true);
    formData.append("corrected_query", editedTranscription);
    formData.append(
      "parent_codevaani_id",
      codevaaniId === null ? 0 : codevaaniId,
    );
    try {
      setCodevaaniId(null);
      const res = await httpService.post(
        `${constants.base_url}/evalpro/voicebot/new_request/${activityID}`,
        formData,
      );
      // console.log("Here yees"+ parentCodevaaniId);
      if (res?.data) {
        // console.log("Edited Query Request Response", res.data);
        const cvid = res?.data?.data?.codeVaani_id;
        const task_id = res?.data?.data?.task_id;
        // console.log("Codevaani Id: ", cvid);
        setCodevaaniId(cvid);
        setInferenceTaskId(res?.data?.data?.inference_task_id);
        addTaskIdToCodevaani(cvid, true, task_id, requestId);
      }
    } catch (error) {
      console.log(`Error sending audio: ${error}`);
      setLoadingTranscription(false);
      setLoadingInference(false);
      setAskResponseFeedback(false);
      setAskTranscriptionFeedback(false);
      displayGlobalMessage(
        error?.response?.data?.detail || "Request Failure, Please Try Again.",
        "error",
      );
    }
  };

  // --- Add Task Id to Codevaani --- Update Task Ids in DB for Polling
  const addTaskIdToCodevaani = async (cvid, isEdited, taskId, requestId) => {
    try {
      console.log("Received Task ID: ", taskId);
      const formData = new FormData();
      formData.append("task_id", taskId);
      formData.append("program_id", activityID);
      const res = await httpService.put(
        `${constants.base_url}/evalpro/voicebot/update_task_ids/${cvid}`,
        formData,
      );
      if (res?.data) {
        console.log("Add-Task-Id Response", res.data);
        const status = res?.data?.data?.status;
        if (status === "successful") {
          if (isEdited) {
            pollingForInference(cvid, true, requestId);
          } else {
            pollingForTranscription(cvid, requestId);
          }
          // displayGlobalMessage("CodeVaani Request added to Queue", "info");
        } else {
          console.log("Failed to add Task Id to Codevaani");
          setLoadingTranscription(false);
          setLoadingInference(false);
          setAskResponseFeedback(false);
          setAskTranscriptionFeedback(false);
          displayGlobalMessage("Request Failure, Please Try Again.", "error");
        }
      }
    } catch (error) {
      console.log(`Error adding Task Id to Codevaani: ${error}`);
      setLoadingTranscription(false);
      setLoadingInference(false);
      setAskResponseFeedback(false);
      setAskTranscriptionFeedback(false);
      displayGlobalMessage(
        error?.response?.data?.detail || "Request Failure, Please Try Again.",
        "error",
      );
    }
  };

  // --- Polling for Transcription---
  const pollingForTranscription = async (cvid, requestId) => {
    if (currentRequestRef.current !== requestId) return;
    setEditedQuery(false);
    try {
      // console.log("Got Id T");
      const res = await httpService.get(
        `${constants.base_url}/evalpro/voicebot/get_status/transcription/${cvid}`,
      );
      if (res?.data) {
        // console.log("Transcription Status: ", res.data);
        const status = res?.data?.data?.status;
        if (status === "successful") {
          setLoadingTranscription(false);
          setAsrTranscription(res?.data?.data?.result?.corrected_query || "");
          setEditedTranscription(
            res?.data?.data?.result?.corrected_query || "",
          );
          pollingForInference(cvid, false, requestId);
        } else if (status === "failed") {
          setLoadingTranscription(false);
          setLoadingInference(false);
          setAskResponseFeedback(false);
          setAskTranscriptionFeedback(false);
          setAsrTranscription("ERROR: Failed to get Response");
          setLlmResponse("ERROR: Failed to get Response");
        } else {
          setTimeout(() => pollingForTranscription(cvid, requestId), 2000);
        }
      }
    } catch (error) {
      console.log(`Error getting Transcription Response: ${error}`);
      setLoadingTranscription(false);
      setLoadingInference(false);
      setAskResponseFeedback(false);
      setAskTranscriptionFeedback(false);
      setAsrTranscription("ERROR: Failed to get Response");
      setLlmResponse("ERROR: Failed to get Response");
      displayGlobalMessage(
        error?.response?.data?.detail ||
          "Error Encountered while fetching Response",
        "error",
      );
    }
  };

  // --- Polling for Inference---
  const pollingForInference = async (cvid, isEdited, requestId) => {
    if (currentRequestRef.current !== requestId) return;
    // console.log("Inside I");
    try {
      const res = await httpService.get(
        `${constants.base_url}/evalpro/voicebot/get_status/inference/${cvid}`,
      );
      if (res?.data) {
        // console.log("Inference Status: ", res.data);
        // console.log("Edited Query PI: "+ isEdited);
        const status = res?.data?.data?.status;
        if (status === "successful") {
          setLoadingInference(false);
          setLlmResponse(res?.data?.data?.result?.codevaani_response || "");
          if (!isEdited) {
            setAskTranscriptionFeedback(true);
          } else {
            setAskTranscriptionFeedback(false);
          }
          setAskResponseFeedback(true);
        } else if (status === "failed") {
          setLoadingInference(false);
          setAskResponseFeedback(false);
          setAskTranscriptionFeedback(false);
          setLlmResponse("ERROR: Failed to get Response");
        } else {
          setTimeout(
            () => pollingForInference(cvid, isEdited, requestId),
            2000,
          );
        }
      }
    } catch (error) {
      console.log(`Error getting Inference Response: ${error}`);
      setLoadingInference(false);
      setAskResponseFeedback(false);
      setAskTranscriptionFeedback(false);
      displayGlobalMessage(
        error?.response?.data?.detail ||
          "Error Encountered while fetching Response",
        "error",
      );
    }
  };

  const saveFeedbackToDB = async (choice, action) => {
    if (codevaaniId) {
      const formData = new FormData();
      formData.append(action, choice);
      formData.append("program_id", activityID);
      try {
        const res = await httpService.put(
          `${constants.base_url}/evalpro/voicebot/capture_response/${codevaaniId}`,
          formData,
        );
        if (res?.data) {
          // console.log("SaveFeedback Status: ", res.data);
          const status = res?.data?.data?.status;
          if (status === "successful") {
            displayGlobalMessage("Feedback Saved", "info");
          }
        }
      } catch (error) {
        console.log(`Error getting Capture Feedback Response: ${error}`);
        displayGlobalMessage(
          error?.response?.data?.detail ||
            "Error Encountered while fetching Response",
          "error",
        );
      }
    }
  };

  const handleTranscriptionFeedback = async (choice) => {
    let feedback = null;
    setSelectedUserAction(null);
    if (selectedTransriptFeedback !== choice) {
      feedback = choice;
    }
    setSelectedTranscriptFeedback(feedback);
    if (feedback !== null) {
      setTranscriptionRated(true);
      let transcription_correct = null;
      if (choice === "like") {
        transcription_correct = true;
      } else if (choice === "dislike") {
        transcription_correct = false;
        setParentCodevaaaniId(codevaaniId);
      }
      // console.log("TrFeed", transcription_correct);

      if (transcription_correct !== null) {
        saveFeedbackToDB(transcription_correct, "transcription_correct");
      }
    } else {
      setTranscriptionRated(false);
    }
  };

  const handleResponseFeedback = async (choice) => {
    let feedback = null;
    if (selectedInferenceFeedback !== choice) {
      feedback = choice;
    }
    setSelectedInferenceFeedback(feedback);
    if (feedback !== null) {
      setResponseRated(true);
      let response_helpful = null;
      if (choice === "like") {
        response_helpful = true;
      } else if (choice === "dislike") {
        response_helpful = false;
      }
      // console.log("InfFeed", response_helpful);

      if (response_helpful !== null) {
        saveFeedbackToDB(response_helpful, "response_helpful");
      }
    }
  };

  const handleUserAction = async (action) => {
    setSelectedUserAction(action);
    setParentCodevaaaniId(codevaaniId);

    if (codevaaniId) {
      const formData = new FormData();
      formData.append("action", action);
      formData.append("program_id", activityID);
      try {
        const res = await httpService.put(
          `${constants.base_url}/evalpro/voicebot/response_actions/${codevaaniId}`,
          formData,
        );
        if (res?.data) {
          // console.log("Save ResponseAction Status: ", res.data);
          const status = res?.data?.data?.status;
          // console.log("status of recording user action: ", status);
        }
      } catch (error) {
        console.log(`Error getting Capture Feedback Response: ${error}`);
      }
    }
  };

  const handleSelectedActivity = async (value) => {
    setSelectedActivity(value);
    setParentCodevaaaniId(null);
  };

  // --- UI ---
  if (!dataReady) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden"></span>
        </div>
      </div>
    );
  }

  if (codevaaniEnabled === false) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh", paddingLeft: "15px", paddingRight: "15px" }}
      >
        CodeVaani is not available for this course
      </div>
    );
  } else if (codevaaniAvailable === false) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh", paddingLeft: "15px", paddingRight: "15px" }}
      >
        CodeVaani is only available for Programming Acitvity
      </div>
    );
  } else {
    return (
  <div
    style={{
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box",
      overflow: "hidden",
      padding: "1rem",
    }}
  >
    {/* 1 & 2. Scrollable Top Content Area */}
    <div
      style={{
        flex: "1 1 auto",
        overflowY: "auto",
        overflowX: "hidden",
        minHeight: 0, // Critical for Flexbox overflow scrolling
        paddingRight: "0.5rem",
      }}
    >
      {/* 1. What We Heard Section */}
      <div className="d-flex align-items-center gap-2 flex-wrap mb-2">
        <text className="m-0" style={{ fontSize: "small", fontWeight: "bold" }}>What I heard / जो मैंने सुना</text>
        <span
          className="d-inline-flex justify-content-center align-items-center rounded-circle border"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={`This is what I heard from your voice / यह वह है जो मैंने आपकी आवाज़ से सुना`}
          style={{
            width: "20px",
            height: "20px",
            fontSize: "0.8rem",
            cursor: "pointer",
            flexShrink: 0,
          }}
        >
          i
        </span>
      </div>

      <div
        className="border p-3 bg-light w-100"
        style={{
          minHeight: "60px",
          maxHeight: "180px",
          overflowY: "auto",
          borderRadius: "5px",
          wordBreak: "break-word",
          overflowWrap: "anywhere",
        }}
      >
        {/* Transcription display / edit area */}
        {loadingTranscription ? (
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden"></span>
            </div>
          </div>
        ) : isEditingTranscription ? (
          <textarea
            id="editedTranscription"
            value={editedTranscription || asrTranscription}
            onChange={(e) => setEditedTranscription(e.target.value)}
            rows="4"
            className="form-control w-100"
          />
        ) : (
          asrTranscription || ""
        )}

        {/* Edit Query Save / Cancel controls */}
        {isEditingTranscription && (
          <div className="text-end mt-2">
            <button
              className="px-2 py-1 bg-red-500 text-white rounded-lg border-none"
              onClick={() => setIsEditingTranscription(false)}
            >
              Cancel
            </button>
            &emsp;
            <button
              className="px-2 py-1 bg-blue-500 text-white rounded-lg border-none"
              onClick={() => sendRequestWithEditedTranscription()}
            >
              Send
            </button>
          </div>
        )}
      </div>

      {/* Left-aligned Feedback & Edit Controls */}
      <div className="d-flex align-items-center gap-2 mt-2 flex-wrap">
        {asrTranscription && askTranscriptionFeedback && audioSent && (
          <>
            <button
              className="btn btn-sm p-0 me-1"
              onClick={() => handleTranscriptionFeedback("like")}
            >
              <FaRegThumbsUp
                size={20}
                className={`cursor-pointer transition-colors duration-200 ${
                  selectedTransriptFeedback === "like"
                    ? "text-blue-600"
                    : "text-black hover:text-blue-400"
                }`}
              />
            </button>
            <button
              className="btn btn-sm p-0 me-2"
              onClick={() => handleTranscriptionFeedback("dislike")}
            >
              <FaRegThumbsDown
                size={20}
                className={`cursor-pointer transition-colors duration-200 ${
                  selectedTransriptFeedback === "dislike"
                    ? "text-red-600"
                    : "text-black hover:text-red-700"
                }`}
              />
            </button>
          </>
        )}

        {asrTranscription && !isEditingTranscription && (
          <button
            className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
            onClick={() => setIsEditingTranscription(true)}
          >
            <FaPencilAlt /> Edit
          </button>
        )}
      </div>

      {/* Transcription Dislike Action Prompts */}
      {asrTranscription &&
        transcriptionRated &&
        selectedTransriptFeedback === "dislike" &&
        !selectedUserAction && (
          <div className="space-x-2 mt-2 flex-wrap">
            Would you like to &nbsp;
            <button
              onClick={() => handleUserAction("edit_query")}
              className="px-2 py-1 bg-blue-500 text-white rounded border-none my-1"
            >
              Edit Query
            </button>
            &nbsp; OR &nbsp;
            <button
              onClick={() => handleUserAction("re-record")}
              className="px-2 py-1 bg-blue-500 text-white rounded border-none my-1"
            >
              Re-record Query
            </button>
          </div>
        )}

      {selectedUserAction === "edit_query" && (
        <p className="text-gray-700 mt-2">
          1. Click on the Edit button <br /> 2. After editing, click on Send
          button
        </p>
      )}

      {selectedUserAction === "re-record" && (
        <p className="text-gray-700 mt-2">
          Click on &nbsp;
          <span className="inline-block transform px-2 py-1 rounded bg-blue-500 text-white rotate-90">
            ↻
          </span>
          &nbsp; icon from <big>`Record your Question`</big> section
        </p>
      )}

      {/* 2. CodeVaani Response Section */}
      <div className="d-flex align-items-center gap-2 flex-wrap mt-4 mb-2">
        <text className="m-0" style={{ fontSize: "small", fontWeight: "bold" }}>Response / जवाब</text>
        <span
          className="d-inline-flex justify-content-center align-items-center rounded-circle border"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={`Here’s the answer to your question / यहाँ आप अपने प्रश्न का उत्तर पाएँगे`}
          style={{
            width: "20px",
            height: "20px",
            fontSize: "0.8rem",
            cursor: "pointer",
            flexShrink: 0,
          }}
        >
          i
        </span>
      </div>

      <div
        className="border p-3 bg-light w-100"
        style={{
          minHeight: "60px",
          maxHeight: "220px",
          overflowY: "auto",
          borderRadius: "5px",
          wordBreak: "break-word",
          overflowWrap: "anywhere",
        }}
      >
        {loadingInference ? (
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden"></span>
            </div>
          </div>
        ) : (
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(marked.parse(llmResponse || "")),
            }}
          />
        )}
      </div>

      {/* Left-aligned Response Feedback Buttons */}
      {llmResponse && askResponseFeedback && audioSent && (
        <div className="d-flex align-items-center gap-2 mt-2 flex-wrap">
          <button
            className="btn btn-sm p-0 me-1"
            onClick={() => handleResponseFeedback("like")}
          >
            <FaRegThumbsUp
              size={20}
              className={`cursor-pointer transition-colors duration-200 ${
                selectedInferenceFeedback === "like"
                  ? "text-blue-600"
                  : "text-black hover:text-blue-400"
              }`}
            />
          </button>
          <button
            className="btn btn-sm p-0"
            onClick={() => handleResponseFeedback("dislike")}
          >
            <FaRegThumbsDown
              size={20}
              className={`cursor-pointer transition-colors duration-200 ${
                selectedInferenceFeedback === "dislike"
                  ? "text-red-600"
                  : "text-black hover:text-red-700"
              }`}
            />
          </button>
        </div>
      )}

      {/* AI Disclaimer */}
      <div className="mt-2 text-center mb-3">
        <small style={{ color: "gray", fontSize: "x-small", fontWeight: "bold" }}>
          This response is AI-generated and may be wrong.
        </small>
      </div>
    </div>

    {/* 3. Anchored Bottom Section */}
    <div
      className="border-top pt-3 mt-2 w-100"
      style={{
        flex: "0 0 auto",
        backgroundColor: "#fff",
      }}
    >
      {/* Select Language Dropdown */}
      <div className="mb-3">
        <div className="d-flex align-items-center gap-1 mb-2">
          <label htmlFor="selectTranscriptionLanguage" className="form-label mb-0">
            Select Language:
          </label>
          <span
            className="d-inline-flex justify-content-center align-items-center rounded-circle border"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={`Choose the language you’ll speak in / वह भाषा चुनें जिसमें आप बोलेंगे`}
            style={{
              width: "20px",
              height: "20px",
              fontSize: "0.8rem",
              cursor: "pointer",
              flexShrink: 0,
            }}
          >
            i
          </span>
					<select
          id="selectTranscriptionLanguage"
          className="form-select"
          value={selectedTranscriptLang}
          onChange={(e) => {
            setSelectedTranscriptLang(e.target.value);
            e.target.size = 1;
            e.target.blur();
          }}
          onFocus={(e) => (e.target.size = 5)}
          onBlur={(e) => (e.target.size = 1)}
          style={{ overflowY: "auto" }}
        >
          {transcriptionLanguageList.map((lang, index) => (
            <option key={index} value={lang.val}>
              {lang.key}
            </option>
          ))}
        </select>
        </div>
				<AudioRecorder
					onRecordingReady={({ blob, extradata }) => {
						handleNewRequest(blob);
					}}
				/>
      </div>
    </div>
  </div>
);
  }
};
